import React, {useEffect, useRef, useState} from 'react';

const Dropdown = ({dropdownArr}) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);


    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        window.addEventListener('click', handleClickOutside);
        return () => {
            window.removeEventListener('click', handleClickOutside);
        };
    }, []);

    return (
        <div className="dropdown" ref={dropdownRef}>
            <button className="btn plan-upgrade-btn" onClick={toggleMenu}>
                <span className="d-flex bi bi-three-dots"></span>
            </button>
            {isOpen && (
                <ul className="dropdown-menu show">
                    {dropdownArr}
                </ul>
            )}
        </div>
    );
};

export default Dropdown;
